import { useAuth } from '@hourly/contexts/AuthContext';
import { detectMobileDevice } from '@hourly/utilities';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import Loader from '../_shared/components/Loader';
import { useDirectLogin } from './data/hooks/useDirectLogin';

const DirectLogin = () => {
  const { sessionState, updateSessionState, logout } = useAuth();

  const navigate = useNavigate();

  const [params] = useSearchParams();
  const hourlyToken = params.get('ht');
  const partnerId = params.get('partnerId');

  const isMobile = detectMobileDevice();

  useDirectLogin({
    hourlyToken: !isMobile && hourlyToken ? hourlyToken : '',
    partnerId: partnerId ?? '',
    session: sessionState,
    logout,
    onSuccess: ({ user, partner }) => {
      updateSessionState({
        userId: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        profilePhoto: user.profilePhoto,
        partnerId: partner.id,
        isInOnboarding: partner.isInOnboarding,
      });

      const navigationPath = partner.isInOnboarding ? '/onboarding' : '/referrals';
      navigate(navigationPath);
    },

    onError: () => {
      navigate('/logout');
    },
  });

  if (isMobile) {
    return <Navigate to="/mobile-unsupported" />;
  }

  if (!hourlyToken) {
    return <Navigate to="/login" />;
  }

  return <Loader />;
};

export default DirectLogin;
